import { render } from "./MainDesktop.vue?vue&type=template&id=f3cb358a&scoped=true"
import script from "./MainDesktop.vue?vue&type=script&lang=js"
export * from "./MainDesktop.vue?vue&type=script&lang=js"

import "./MainDesktop.vue?vue&type=style&index=0&id=f3cb358a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3cb358a"]])

export default __exports__